import { module } from 'angular';
import kformComponent from './kform.component';
import kformComponentDirective from './component/kform-component.directive';
import kformComponentTooltipDirective
	from './component-tooltip/kform-component-tooltip.directive';
import kformContentComponent from './content/kform-content.component';
import kformFormDirective from './form/kform-form.directive';
import kformHtmlElementDirective from './html-element/kform-html-element.directive';
import kformScopeFactory from './form/kform-scope.factory';
// eslint-disable-next-line unicorn/prevent-abbreviations
import kformDevToolbar from './dev-toolbar/kform-dev-toolbar.component';
import kformElementComponent from './element/kform-element.component';
import kformElementBindTemplateDirective from './element/kform-element-bind-template.directive';
import kformErrorsDirective from './errors/kform-errors.directive';
import kformFileLabelComponent from './file-label/kform-file-label.component';
import kformInputMaskDirective from './input-mask/kform-input-mask.directive';
import kformInputPasswordDirective from './input-password/kform-input-password.directive';
import kformMaxDirective from './max/kform-max.directive';
import kformMinDirective from './min/kform-min.directive';
import kformScriptEditorComponent from './script-editor/kform-script-editor.component';
import kformSelectItemDirective from './select-item/kform-select-item.directive';
import kformTabAttributComponent from './tab-attribut/kform-tab-attribut.component';
import kformTabFileComponent from './tab-file/kform-tab-file.component';
import kformTabFileMultipleComponent from '~/components/kform/tab-file-multiple/kform-tab-file-multiple.component';
import kformTabFormComponent from './tab-form/kform-tab-form.component';
import kformTabHistoryComponent from './tab-history/kform-tab-history.component';
import kformTabOpentextComponent from './tab-opentext/kform-tab-opentext.component';
import kformTabRepreComponent from './tab-repre/kform-tab-repre.component';
import kformTabRightsComponent from './tab-rights/kform-tab-rights.component';
import kformTabWfComponent from './tab-wf/kform-tab-wf.component';
import kformTreeComponent from './tree/kform-tree.component';
import kformToolbarComponent from './toolbar/kform-toolbar.component';
import customValidatorDirective from './custom-validator/custom-validator.directive';
import methodService from './method.service';

import './kform.run';
import './kform.scss';

// kform components
import './components/common/common.run';
import './components/textfield/textfield.config';
import './components/textfield/textfield.run';
import './components/button/button.config';
import './components/button/button.run';
import './components/checkbox/checkbox.config';
import './components/checkbox/checkbox.run';
import './components/columns/columns.config';
import './components/columns/columns.run';
import './components/currency/currency.config';
import './components/currency/currency.run';
import './components/custom/custom.config';
import './components/custom/custom.run';
import './components/datagrid/datagrid.config';
import './components/datagrid/datagrid.run';
import './components/datetime/datetime.config';
import './components/datetime/datetime.run';
import './components/email/email.config';
import './components/email/email.run';
import './components/fieldset/fieldset.config';
import './components/fieldset/fieldset.run';
import './components/form/form.config';
import './components/form/form.run';
import '~/components/kform/components/fileCurrent/fileCurrent.config';
import '~/components/kform/components/fileCurrent/fileCurrent.run';
import '~/components/kform/components/fileUpload/fileUpload.config';
import '~/components/kform/components/fileUpload/fileUpload.run';
import './components/geo/geo.config';
import './components/geo/geo.run';
import './components/htmlelement/htmlelement.config';
import './components/htmlelement/htmlelement.run';
import '~/components/kform/components/jsoneditor/jsoneditor.config';
import '~/components/kform/components/jsoneditor/jsoneditor.run';
import './components/kid/kid.config';
import './components/kid/kid.run';
import './components/kpath/kpath.config';
import './components/kpath/kpath.run';
import './components/ktable/ktable.config';
import './components/ktable/ktable.run';
import './components/name/name.config';
import './components/name/name.run';
import './components/number/number.config';
import './components/number/number.run';
import './components/panel/panel.config';
import './components/panel/panel.run';
import '~/components/kform/components/phoneNumber/phoneNumber.config';
import '~/components/kform/components/phoneNumber/phoneNumber.run';
import '~/components/kform/components/postaladdress/postaladdress.config';
import '~/components/kform/components/postaladdress/postaladdress.run';
import './components/qr/qr.config';
import './components/qr/qr.run';
import './components/qty/qty.config';
import './components/qty/qty.run';
import './components/radio/radio.config';
import './components/radio/radio.run';
import './components/repre/repre.config';
import './components/repre/repre.run';
import './components/select/select.config';
import './components/select/select.run';
import '~/components/kform/components/smartfield/smartfield.config';
import '~/components/kform/components/smartfield/smartfield.run';
import './components/tabs/tabs.config';
import './components/tabs/tabs.run';
import './components/password/password.config';
import './components/password/password.run';
import '~/components/kform/components/texteditor/texteditor.config';
import './components/textarea/textarea.config';
import './components/textarea/textarea.run';
import './components/uri/uri.config';
import './components/uri/uri.run';
import './components/well/well.config';
import './components/well/well.run';
import './components/wfCurrent/wfCurrent.config';
import './components/wfCurrent/wfCurrent.run';
import './components/wfHisto/wfHisto.config';
import './components/wfHisto/wfHisto.run';

export default module('app')

	.component('kform', kformComponent)
	.component('kformContent', kformContentComponent)
	.component('kformDevToolbar', kformDevToolbar)
	.component('kformElement', kformElementComponent)
	.component('kformFileLabel', kformFileLabelComponent)
	.component('kformTabAttribut', kformTabAttributComponent)
	.component('kformTabFile', kformTabFileComponent)
	.component('kformTabFileMultiple', kformTabFileMultipleComponent)
	.component('kformTabForm', kformTabFormComponent)
	.component('kformTabHistory', kformTabHistoryComponent)
	.component('kformTabOpentext', kformTabOpentextComponent)
	.component('kformTabRepre', kformTabRepreComponent)
	.component('kformTabRights', kformTabRightsComponent)
	.component('kformTabWf', kformTabWfComponent)
	.component('kformToolbar', kformToolbarComponent)
	.component('kformTree', kformTreeComponent)
	.component('kformScriptEditor', kformScriptEditorComponent)

	.directive('customValidator', customValidatorDirective)
	.directive('kformComponent', kformComponentDirective)
	.directive('kformComponentTooltip', kformComponentTooltipDirective)
	.directive('kformElementBindTemplate', kformElementBindTemplateDirective)
	.directive('kformErrors', kformErrorsDirective)
	.directive('kformForm', kformFormDirective)
	.directive('kformHtmlElement', kformHtmlElementDirective)
	.directive('kformInputMask', kformInputMaskDirective)
	.directive('kformInputPassword', kformInputPasswordDirective)
	.directive('kformMax', kformMaxDirective)
	.directive('kformMin', kformMinDirective)
	.directive('kformSelectItem', kformSelectItemDirective)

	.factory('KformScope', kformScopeFactory)

	.factory('MethodService', methodService)

	.name;
